import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../services/api';
import arrayCatcher from '../../../../helpers/errorCatcher';

export const getExpenseCategoryListThunk = createAsyncThunk(
  'expenseCategories/list',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.operations.expenseCategories.list();
      return response.data.data;
    } catch (err: any) {
      arrayCatcher(err?.code);
      return rejectWithValue(err);
    }
  },
);
